import limitService from '../../api/farmer'

const state = {
  limit: 0
}

const mutations = {
  setFarmerLimit (state, limit) {
    state.limit = limit
  }
}

const actions = {
  getFarmerLimit ({ commit, dispatch }, id) {
    limitService.getFarmerLimit(id).then(response => {
      commit('setFarmerLimit', response.data)
    }).catch(error => {
      dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' }, { root: true })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
